
<div class="container">
    <mat-progress-spinner color="accent" mode="indeterminate"></mat-progress-spinner>
    <p class="loading-message">{{message}}</p>
</div>
